<script lang="ts">
	import { onMount } from 'svelte';
	import Circle from './Circle.svelte';
	import { gsap } from 'gsap';

	const {
		x,
		r,
		steps
	}: {
		x: number;
		r: number;
		steps: number[];
	} = $props();

	const randomDelay = 3000;

	let currentTimer: number = 0;
	let pos = $state({ value: steps[Math.floor(Math.random() * steps.length)] });
	let blur = $state({ value: 0 });

	function gotoNextStep() {
		const targetStep = steps[Math.floor(Math.random() * steps.length)];
		gsap.to(pos, { value: targetStep, duration: 1, ease: 'power2.inOut' });
		gsap.to(blur, { value: Math.random() < 0.5 ? 0 : 4, duration: 1, ease: 'power2.inOut' });
		clearTimeout(currentTimer);
		currentTimer = setTimeout(() => gotoNextStep(), 1000 + Math.random() * randomDelay);
	}

	$effect(() => {
		pos.value = steps[Math.floor(Math.random() * steps.length)];
	});

	onMount(() => {
		currentTimer = setTimeout(() => gotoNextStep(), 1000 + Math.random() * randomDelay);
		return () => {
			clearTimeout(currentTimer);
		};
	});
</script>

<Circle {x} y={pos.value} {r} blur={blur.value} id="curv"></Circle>
